"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimeSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _Menu = require("./Menu");
var _DateRange = _interopRequireDefault(require("@material-ui/icons/DateRange"));
var _styles = require("@material-ui/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _DateTimePicker = require("./DateTimePicker");
var _moment = _interopRequireDefault(require("moment"));
var _Modal = require("./Modal");
var _Button = require("./Button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    btnDiv: {
      padding: theme.spacing(3, 1, 1),
      display: "flex",
      justifyContent: "flex-end",
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    },
    btn: {
      margin: theme.spacing(0, 1)
    }
  };
});
var DateTimeSelector = function DateTimeSelector(props) {
  var _t, _t2, _t3, _t4, _t5;
  var mobile = props.mobile,
    disabled = props.disabled,
    dense = props.dense,
    day = props.day,
    placement = props.placement,
    onChangeDay = props.onChangeDay,
    _onClick = props.onClick,
    t = props.t,
    activeBtn = props.activeBtn;
  var classes = useStyles();
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMenu = _useState2[0],
    setOpenMenu = _useState2[1];
  var _useState3 = (0, _react.useState)(day),
    _useState4 = _slicedToArray(_useState3, 1),
    defaultDay = _useState4[0];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    rootRef: anchorRef,
    readOnly: true,
    select: true,
    dense: dense,
    value: day === null || day === void 0 ? void 0 : day.format("MMM D, YYYY, hh:mm A"),
    disabled: disabled,
    endIcon: /*#__PURE__*/_react.default.createElement(_DateRange.default, null),
    onClick: disabled ? undefined : function () {
      setOpenMenu(function (o) {
        return !o;
      });
    }
  }), !mobile && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    open: openMenu,
    onClickAway: function onClickAway() {
      return setOpenMenu(false);
    },
    anchorEl: anchorRef.current,
    placement: placement !== null && placement !== void 0 ? placement : "bottom-start",
    modifiers: {
      offset: {
        enabled: true,
        offset: "0, 4px"
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DateTimePicker.DateTimePicker, {
    day: day,
    mobile: mobile,
    onChangeDay: onChangeDay,
    t: t
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.btnDiv
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.btn,
    disabled: day === null || day === void 0 ? void 0 : day.isSame(defaultDay)
    // mantis - 10745, clear버튼 누르면 현재시간으로 적용 (Leehj)
    // onClick={() => defaultDay && onChangeDay?.(defaultDay)}
    ,
    onClick: function onClick() {
      return onChangeDay === null || onChangeDay === void 0 ? void 0 : onChangeDay((0, _moment.default)());
    }
  }, (_t = t === null || t === void 0 ? void 0 : t("Clear")) !== null && _t !== void 0 ? _t : "Clear"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    color: "primary",
    variant: "contained",
    className: classes.btn
    // mantis - 10649, activeBtn가 true면 ok버튼 항상 활성화 처리 (Leehj)
    ,
    disabled: !activeBtn && (day === null || day === void 0 ? void 0 : day.isSame(defaultDay)),
    onClick: function onClick() {
      day && (_onClick === null || _onClick === void 0 ? void 0 : _onClick(day));
      setOpenMenu(false);
    }
  }, (_t2 = t === null || t === void 0 ? void 0 : t("OK")) !== null && _t2 !== void 0 ? _t2 : "OK")))), mobile && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    open: openMenu,
    heading: (_t3 = t === null || t === void 0 ? void 0 : t("Date and time")) !== null && _t3 !== void 0 ? _t3 : "Date and time",
    close: true,
    fullSize: true,
    noPadding: true,
    onClose: function onClose() {
      return setOpenMenu(false);
    },
    mobile: mobile,
    content: /*#__PURE__*/_react.default.createElement(_DateTimePicker.DateTimePicker, {
      day: day,
      mobile: mobile,
      onChangeDay: onChangeDay
    }),
    RButton: (_t4 = t === null || t === void 0 ? void 0 : t("OK")) !== null && _t4 !== void 0 ? _t4 : "OK",
    LButton: (_t5 = t === null || t === void 0 ? void 0 : t("Clear")) !== null && _t5 !== void 0 ? _t5 : "Clear"
    // mantis - 10649, activeBtn가 true면 ok버튼 항상 활성화 처리 (Leehj)
    ,
    RButtonDisabled: !activeBtn && (day === null || day === void 0 ? void 0 : day.isSame(defaultDay)),
    LButtonDisabled: day === null || day === void 0 ? void 0 : day.isSame(defaultDay),
    onClickPositive: function onClickPositive() {
      day && (_onClick === null || _onClick === void 0 ? void 0 : _onClick(day));
      setOpenMenu(false);
    }
    // mantis - 10745, clear버튼 누르면 현재시간으로 적용 (Leehj)
    // onClickNegative={() => defaultDay && onChangeDay?.(defaultDay)}
    ,
    onClickNegative: function onClickNegative() {
      return onChangeDay === null || onChangeDay === void 0 ? void 0 : onChangeDay((0, _moment.default)());
    }
  }));
};
exports.DateTimeSelector = DateTimeSelector;